<script lang="ts" setup>
import ContentMenu from '../components/content/ContentMenu.vue';
import ContentList from '../components/content/ContentList.vue';
import ContentSchedules from '../components/content/ContentSchedules.vue';
import ContentDiscounts from '../components/content/ContentDiscounts.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <ContentMenu />
  <ContentList v-if="route.path === '/content'" />
  <ContentSchedules v-if="route.path === '/content/schedule'" />
  <ContentDiscounts v-if="route.path === '/content/discounts'" />
</template>
